<div class="bn-register-slider">
  @if (loading) {
    <bn-web-ui-loading
      [isTransparent]="true"
      [showSpinner]="true" />
  } @else {
    @if (configuration?.title) {
      <div
        class="bn-register-slider__title mb-5"
        [innerHtml]="configuration?.title"></div>
    }
    @if (configuration?.description) {
      <div
        class="bn-register-slider__description mb-6"
        [innerHtml]="configuration?.description"></div>
    }
    <!-- Little Stats Cards -->
    @if (configuration?.littleStatsCards) {
      <div class="bn-register-slider__statistics mb-6 p-3">
        @for (card of configuration?.littleStatsCards; track card) {
          <div class="bn-register-slider__statistics__item">
            <div
              class="bn-register-slider__statistics__item__title"
              [innerHtml]="card?.title"></div>
            <div
              class="bn-register-slider__statistics__item__description"
              [innerHtml]="card?.description"></div>
          </div>
        }
      </div>
    }
    <!-- Tips -->
    <div class="bn-register-slider__tips mb-6">
      @for (tip of configuration?.tips; track tip) {
        <div class="bn-register-slider__tips__item">
          @if (tip?.iconSrc) {
            <img
              class="bn-register-slider__tips__item__icon"
              [src]="tip?.iconSrc" />
          }
          @if (tip?.faIcon && tip.faIcon) {
            <fa-icon
              class="me-3"
              [icon]="tip.faIcon"
              [size]="tip.faSize" />
          }
          <span
            class="bn-register-slider__tips__item__text"
            [innerHtml]="tip?.text">
          </span>
        </div>
      }
    </div>
    @if (configuration?.tipsDescription) {
      <div
        class="bn-register-slider__tips__description"
        [innerHtml]="configuration?.tipsDescription"></div>
    }
    @if (configuration?.tipsButton; as tipsButton) {
      <div class="mt-4">
        @if (tipsButton.href) {
          <a
            bn-web-ui-button
            data-e2e="AuthPagesRegisterSliderTipsButton"
            itemStyle="stroke"
            size="xl"
            target="_blank"
            [href]="tipsButton.href"
            >{{ tipsButton.text }}</a
          >
        }
      </div>
    }
    <div
      class="bn-register-slider__image"
      [ngClass]="hoverImageClasses">
      @if (configuration?.image?.src) {
        <img
          [alt]="configuration?.image?.alt || 'Bunny'"
          [src]="configuration?.image?.src" />
      }
    </div>
    <div
      class="pe-7"
      (mouseenter)="onMouseOver()"
      (mouseleave)="onMouseLeave()">
      <div class="overflow-hidden">
        <div
          class="bn-register-slider__comments"
          [style.left]="-activeIndex * 100 + '%'"
          [style.width]="'calc(' + configuration?.comments?.length + '*' + '100%' + ')'">
          @for (comment of configuration?.comments; track comment; let index = $index) {
            <div
              class="bn-register-slider__comments__item"
              [style.width]="100 / (configuration?.comments?.length || 0) + '%'">
              @if (comment?.title) {
                <div
                  class="bn-register-slider__comments__item__title"
                  [innerHtml]="comment?.title"></div>
              }
              @if (comment?.text) {
                <div
                  class="bn-register-slider__comments_item__description"
                  [innerHtml]="comment?.text"></div>
              }
              <div class="bn-register-slider__comments__item__author">
                @if (comment?.avatarImageSrc) {
                  <img
                    alt="User avatar"
                    class="bn-register-slider__comments__item__author__avatar"
                    [src]="comment?.avatarImageSrc" />
                }
                <span class="bn-register-slider__comments__item__author__name">{{ comment?.author }}</span>
              </div>
            </div>
          }
        </div>
      </div>
      @if ((configuration?.comments?.length || 0) > 1) {
        <div class="bn-register-slider__pagination">
          @for (item of configuration?.comments; track item; let index = $index) {
            <div
              class="bn-register-slider__pagination__item"
              data-e2e="AuthPagesRegisterSliderPaginationItem"
              [ngClass]="{
                'bn-register-slider__pagination__item--selected': activeIndex === index,
              }"
              (click)="onPaginationClick(index)"></div>
          }
        </div>
      }
    </div>
  }
</div>
